export const BD_AGE_GROUPS_DISPLAY_NAMES = {
    1: 'Im Alter von 0 bis unter 1 Jahr',
    2: 'Im Alter von 1 bis unter 5 Jahren',
    3: 'Im Alter von 5 bis unter 10 Jahren',
    4: 'Im Alter von 10 bis unter 15 Jahren',
    5: 'Im Alter von 15 bis unter 20 Jahren',
    6: 'Im Alter von 20 bis unter 25 Jahren',
    7: 'Im Alter von 25 bis unter 30 Jahren',
    8: 'Im Alter von 30 bis unter 35 Jahren',
    9: 'Im Alter von 35 bis unter 40 Jahren',
    10: 'Im Alter von 40 bis unter 45 Jahren',
    11: 'Im Alter von 45 bis unter 50 Jahren',
    12: 'Im Alter von 50 bis unter 55 Jahren',
    13: 'Im Alter von 55 bis unter 60 Jahren',
    14: 'Im Alter von 60 bis unter 65 Jahren',
    15: 'Im Alter von 65 bis unter 70 Jahren',
    16: 'Im Alter von 70 bis unter 75 Jahren',
    17: 'Im Alter von 75 bis unter 80 Jahren',
    18: 'Im Alter von 80 bis unter 85 Jahren',
    19: 'Im Alter von 85 bis unter 90 Jahren',
    20: 'Im Alter von 90 bis unter 95 Jahren',
    21: '95 Jahre und älter',
    22: 'Alter unbekannt'
};


